export default __webpack_public_path__ + "static/media/ProductsToBuy.36d6f1e0.png";